import { DataProvider } from 'react-admin';

const addInfraMethods = (dataProvider: DataProvider, httpClient) => {
    return {
        ...dataProvider,

        getAny: async (resource, params) => {
            //let query = (params != undefined && params != '') ? `?${stringify(params)}` : '';
            const query =
                params !== undefined && params !== '' ? `?${params}` : '';

            const url = `${process.env.REACT_APP_INFRA_API}/${resource}${query}`;
            //console.log('getAny:' + url);

            const { json } = await httpClient(url);
            return { data: json };
        },

        getTestScenarios: async () => {
            const url = `${process.env.REACT_APP_INFRA_API}/admin/test-scenarios`;
            const { json } = await httpClient(url);
            return { data: json };
        },

        createTestScenario: async (data: any) => {
            const url = `${process.env.REACT_APP_INFRA_API}/admin/test-scenarios`;
            const { json } = await httpClient(url, {
                method: 'POST',
                body: JSON.stringify(data),
            });
            return { data: json };
        },

        deleteTestScenario: async (name: string) => {
            const url = `${process.env.REACT_APP_INFRA_API}/admin/test-scenarios/${encodeURIComponent(name)}`;
            const { json } = await httpClient(url, {
                method: 'DELETE',
            });
            return { data: json };
        },

        persistTestScenario: async (name: string) => {
            const url = `${process.env.REACT_APP_INFRA_API}/admin/test-scenarios/${encodeURIComponent(name)}/persist`;
            const { json } = await httpClient(url, {
                method: 'POST',
            });
            return { data: json };
        },

        unpersistTestScenario: async (name: string) => {
            const url = `${process.env.REACT_APP_INFRA_API}/admin/test-scenarios/${encodeURIComponent(name)}/persist`;
            const { json } = await httpClient(url, {
                method: 'DELETE',
            });
            return { data: json };
        },

        getPersistedTestScenarios: async () => {
            const url = `${process.env.REACT_APP_INFRA_API}/admin/test-scenarios/persisted`;
            const { json } = await httpClient(url);
            return { data: json };
        },

        rotateJwtKeys: async (
            keys: Array<{
                application_guid: string;
                api_key: string;
                algorithm?: string;
                env?: string | null;
            }>
        ) => {
            const url = `${process.env.REACT_APP_INFRA_API}/admin/jwt-keys/rotate`;
            const { json } = await httpClient(url, {
                method: 'POST',
                body: JSON.stringify({ keys }),
            });
            return { data: json };
        },

        revokeJwtKey: async (kid: string) => {
            const url = `${process.env.REACT_APP_INFRA_API}/admin/jwt-keys/${encodeURIComponent(kid)}/revoke`;
            const { json } = await httpClient(url, {
                method: 'PUT',
            });
            return { data: json };
        },

        // OAuth Client application link management
        createOAuthClientApp: async (clientGuid: string, data: any) => {
            const url = `${process.env.REACT_APP_INFRA_API}/admin/oauth-clients/${encodeURIComponent(clientGuid)}/applications`;
            const { json } = await httpClient(url, {
                method: 'POST',
                body: JSON.stringify(data),
            });
            return { data: json };
        },

        updateOAuthClientApp: async (
            clientGuid: string,
            ocaGuid: string,
            data: any
        ) => {
            const url = `${process.env.REACT_APP_INFRA_API}/admin/oauth-clients/${encodeURIComponent(clientGuid)}/applications/${encodeURIComponent(ocaGuid)}`;
            const { json } = await httpClient(url, {
                method: 'PUT',
                body: JSON.stringify(data),
            });
            return { data: json };
        },

        deleteOAuthClientApp: async (clientGuid: string, ocaGuid: string) => {
            const url = `${process.env.REACT_APP_INFRA_API}/admin/oauth-clients/${encodeURIComponent(clientGuid)}/applications/${encodeURIComponent(ocaGuid)}`;
            const { json } = await httpClient(url, {
                method: 'DELETE',
            });
            return { data: json };
        },

        deleteOAuthClientPermanent: async (guid: string) => {
            const url = `${process.env.REACT_APP_INFRA_API}/admin/oauth-clients/${encodeURIComponent(guid)}?permanent=true`;
            const { json } = await httpClient(url, {
                method: 'DELETE',
            });
            return { data: json };
        },

        getInfoSchema: async (resource: string, type: string) => {
            const url = `${process.env.REACT_APP_INFRA_API}/admin/schemas/${encodeURIComponent(resource)}/${encodeURIComponent(type)}`;
            const { json } = await httpClient(url);
            return { data: json };
        },
    };
};

export default addInfraMethods;
